"use strict";

import { on, findAll, findAllIn, findIn } from '@elements/dom-utils';
import axios from 'axios';
import asyncAppend from '@elements/async-append';

// Ajax-loaded accordion content loader
// Usage classes (example):
// - Wrapper:        .js-ajax-accordion
// - Item:           .js-ajax-accordion__item
// - Toggle button:  .card__toggle (or .js-ajax-accordion__btn) with data-action="/your/endpoint"
// - Loading node:   .js-ajax-accordion__loading (optional)
// - Result node:    .js-ajax-accordion__result (required)
//
// Behavior:
// Clicking the toggle button sends a POST request to the URL from data-action
// and injects the returned HTML into the nearest item's .js-ajax-accordion__result.

const LOADED_BTN_CLASS = 'is-ajax-loaded';

export function init () {
  // Find all accordion scopes on the page
  const accordions = findAll('.js-ajax-accordion');
  if (!accordions || !accordions.length) return;

  accordions.forEach((accordion) => {
    // Find buttons inside this accordion
    const buttons = findAllIn('.js-ajax-accordion__btn, .card__toggle', accordion);
    if (!buttons || !buttons.length) return;

    buttons.forEach((btn) => {
      on('click', (evt) => {
          console.log('test');
        evt.preventDefault();

        // Guard: load only on first click per button by marking with a class
        if (btn && btn.classList && btn.classList.contains(LOADED_BTN_CLASS)) {
          return;
        }
        if (btn && btn.classList) {
          btn.classList.add(LOADED_BTN_CLASS);
        }

        // Detect the hosting item for scoping result + loading nodes
        const item = (btn.closest && btn.closest('.js-ajax-accordion__item')) || accordion;

        // Resolve target action URL
        const action = btn.getAttribute('data-action') || (item && item.getAttribute('data-action'));
        if (!action) return;

        // Prepare request
        const pendingRequest = axios({
          method: 'POST',
          url: action,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        // Targets within the item scope (fall back to accordion if not found on item)
        const resultTargets = findAllIn('.js-ajax-accordion__result', item) || findAllIn('.js-ajax-accordion__result', accordion);
        const loadingTargets = findAllIn('.js-ajax-accordion__loading', item) || findAllIn('.js-ajax-accordion__loading', accordion);

        // Inject returned HTML
          asyncAppend({
              target: resultTargets,
              loading: loadingTargets
          }, pendingRequest.then((x) => {
              // Re-initialize accordion after content is loaded
              setTimeout(() => {
                  init();
              }, 100);
              return x.data;
          }));
      }, btn);
    });
  });
}
